export default __webpack_public_path__ + "static/media/x40.cfb70ca4.png";